import { Types } from "actions/companiesTable";
import { createReducer } from "utils/reducer";
import { createSelector } from "reselect";
import * as R from "ramda";
import { cpapWalkInCount, cgmWalkInCount } from "utils/walk-in-orders";

const initialState = {
  companies: [],
  statsLoaded: false,
  isLoadingStats: false
};

export default createReducer(initialState, {
  [Types.COMPANIES_BASIC_RESPONSE]: (state, { response }) => ({
    ...state,
    companies: R.propOr([], "companies", response),
    statsLoaded: false
  }),
  [Types.REQUEST_COMPANIES_TABLE]: state => ({
    ...state,
    isLoadingStats: true,
    statsLoaded: false
  }),
  [Types.COMPANIES_TABLE_RESPONSE]: (state, { response }) => {
    const statsCompanies = R.propOr([], "companies", response);
    const statsById = R.indexBy(R.prop("id"), statsCompanies);

    const mergedCompanies = state.companies.map(company => {
      const stats = statsById[company.id];
      if (!stats) return company;
      // S3DEV2-7476: flatten the per-line walk-in breakdown into sortable scalar
      // fields so the query table can sort/filter each column like any other stat.
      return {
        ...company,
        ...stats,
        walk_in_orders_cpap: cpapWalkInCount(stats.walk_in_orders_by_line),
        walk_in_orders_cgm: cgmWalkInCount(stats.walk_in_orders_by_line)
      };
    });

    return {
      ...state,
      companies: mergedCompanies,
      statsLoaded: true,
      isLoadingStats: false
    };
  },
  [Types.COMPANIES_TABLE_FAILURE]: state => ({
    ...state,
    isLoadingStats: false
  }),
  [Types.CLEAR_COMPANY_TABLE]: () => initialState
});

const getCompaniesTableState = state => state.get("companiesTable");
const getCompaniesTableEntries = state =>
  getCompaniesTableState(state).companies || [];
const getStatsLoaded = state =>
  getCompaniesTableState(state).statsLoaded || false;
const getIsLoadingStats = state =>
  getCompaniesTableState(state).isLoadingStats || false;

const getCompaniesTableOptions = createSelector(
  [getCompaniesTableEntries],
  R.map(({ company_name, id }) => ({
    text: company_name,
    value: id
  }))
);

export const selectors = {
  getCompaniesTableEntries,
  getCompaniesTableOptions,
  getStatsLoaded,
  getIsLoadingStats
};
